import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { render, MARK_LINK, NODE_PARAGRAPH } from 'storyblok-rich-text-react-renderer';
import { getPlainText } from '@storyofams/storyblok-toolkit';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';
import FancyTitle from '../fancy-title';

const FAQ_HEADER_BG = 'linear-gradient(135deg, #001c0a 0%, #006837 100%)';

export default function PartnerFAQSection({ blok, ...props }) {
  const data = blok || props;
  const title = data?.title;
  const items = data?.faq_items || data?.items || [];
  const textColor = data?.text_color || 'text-white';
  const borderColor = data?.border_color || '#006837';

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem?.Question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: typeof faqItem?.Answer === 'string' ? faqItem.Answer : getPlainText(faqItem?.Answer),
      },
    })),
  };

  if (!items.length) {
    return null;
  }

  return (
    <section {...storyblokEditable(data)} className="py-12 lg:py-20 partner-faq-section">
      <Container>
        <FancyTitle
          text={title}
          tag="h2"
          textAlign="text-left"
          marginBottom="mb-8"
        />

        <div>
          {items.map((faqItem) => (
            <div
              key={faqItem._uid || faqItem.Question}
              {...storyblokEditable(faqItem)}
              className="quick-insight px-5 pt-5 pb-10 border-2 border-solid rounded my-5"
              style={{ borderColor }}
            >
              <div
                className="flex items-center w-full dark text-white px-4"
                style={{
                  backgroundImage: FAQ_HEADER_BG,
                }}
              >
                <FancyTitle
                  text={faqItem.Question}
                  marginBottom=""
                  fontSize="text-2xl"
                  className={`fancy-title-small w-[calc(100%+16px)] p-[10px] hyphens-auto ${textColor}`}
                  tag="h3"
                />
              </div>

              <div className="pt-6 card-section-content text-base leading-relaxed">
                {typeof faqItem.Answer === 'string' ? (
                  <p>{faqItem.Answer}</p>
                ) : (
                  render(faqItem.Answer, {
                    markResolvers: {
                      [MARK_LINK]: LinkResolver,
                    },
                    nodeResolvers: {
                      [NODE_PARAGRAPH]: (children) => <p className="mt-2">{children}</p>,
                    },
                  })
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </section>
  );
}
